import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { getLoggedUser } from "../redux/actions/usersAction";
import storage, { clearCache } from "../utils/storage";
import { loginRequest } from "../api/azure/authConfig";
import { setGlobalLoader } from "../redux/actions/commonAction";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance, inProgress } = useMsal()
    const dispatch = useDispatch()

    const loading = inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect

    useEffect(() => {
        const auth = storage.getItem("auth")
        if (isAuthenticated && auth) {
            const email = auth.username
            clearCache();
            instance.acquireTokenSilent({
                ...loginRequest,
                account: instance.getActiveAccount(),

            })
                .then((response) => {
                    dispatch(setGlobalLoader(true))
                    dispatch(getLoggedUser(email));
                    return response
                })
                .catch((error) => {
                    instance.acquireTokenPopup({
                        ...loginRequest,
                        account: instance.getActiveAccount()
                    });
                });

        }
        else if (!loading) {
            instance.acquireTokenPopup({
                ...loginRequest,
                account: instance.getActiveAccount()
            });
        }
        // eslint-disable-next-line
    }, [isAuthenticated]);

    return (
        <>
            {loading ? null :
                <Route
                    {...rest}
                    render={(props) =>
                        isAuthenticated ? (
                            <Component {...props} />
                        ) : (
                            <Redirect to="/login" />
                        )
                    }
                />
            }

        </>

    );
};

export default PrivateRoute;
